import styled from "@emotion/styled"
import { InputBase, Typography } from "@mui/material"
import StoreSubScriptions from "GlobalStores/StoreSubScriptions"

export const DefaultLabelTypo = styled(Typography)(({ theme }) => ({
    fontFamily: 'Inter, NotoSansThai',
    fontStyle: 'normal',
    fontSize: StoreSubScriptions.fontSize || 14,
    lineHeight: '20px',
    color: 'var(--input-label)',
    fontWeight: theme?.typography?.label?.fontWeight || 400
}))

export const DefaultInputStyled = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
        boxSizing: 'border-box',
        position: 'relative',
        border: '1px solid var(--input-border)',
        backgroundColor: 'var(--input-bg)',
        fontSize: 16,
        width: '100%',
        padding: '0 16px',
        marginTop: '0px',
        borderRadius: '8px',
        color: 'var(--input-text)',
        fontWeight: 400,
        height: '48px',
        fontFamily: 'Inter, NotoSansThai',
        '&::placeholder': {
            color: 'var(--input-label)',
            opacity: 1
        },
        // filled state: ช่องที่มีค่าแล้วพื้นเป็นฟ้าอ่อน (ต้องมี attribute placeholder ถึงจะทำงาน)
        '&:not(:placeholder-shown)': {
            backgroundColor: 'var(--input-filled-bg)'
        },
        '&:focus': {
            borderColor: 'var(--input-focus)'
        }
    },
    '.MuiOutlinedInput-root': {
        border: '1px solid var(--input-border)',
        borderRadius: 8,
        height: 48
    },
    '.Mui-focused': {
        borderColor: 'var(--input-focus)',
        color: 'var(--input-text)'
    },
    '.MuiOutlinedInput-notchedOutline': {
        display: 'none'
    }
})) 

